import React from 'react';
import { VStack, Text, Button, HStack } from '@chakra-ui/react';
import { ArrowForwardIcon } from '@chakra-ui/icons';
import LogoSection from './LogoSection';
import EmailInputSection from './EmailInputSection';
import PhoneInputSection from './PhoneInputSection';
import DividerWithText from './DividerWithText';
import SocialLoginSection from './SocialLoginSection';
import FooterLinksSection from './FooterLinksSection';

const SignUpCardContent = ({
  mode = 'phone',
  value,
  onChange,
  error,
  onNext,
  onSignIn,
  onPhoneClick,
  onEmailClick
}) => (
  <>
    <LogoSection />
    <Text fontSize="2xl" fontWeight="bold" color="gray.800" textAlign="center" mb={2}>
      Create OSSPID account
    </Text>
    {mode === 'phone' ? (
      <PhoneInputSection
        value={value}
        onChange={onChange}
        error={error}
        onNext={onNext}
      />
    ) : (
      <EmailInputSection
        value={value}
        onChange={onChange}
        error={error}
        onNext={onNext}
      />
    )}
    <HStack justify="center" spacing={1} mb={2} mt={1}>
      <Text color="gray.500" fontSize="sm">Already have an account?</Text>
      <Button variant="link" colorScheme="blue" fontSize="sm" p={0} h="auto" onClick={onSignIn}>
        Sign In
      </Button>
    </HStack>
    <DividerWithText text="Or sign up with" />
    <SocialLoginSection mode={mode} onPhoneClick={onPhoneClick} onEmailClick={onEmailClick} />
    <FooterLinksSection />
  </>
);

export default SignUpCardContent; 